import {
  AppBar,
  Box,
  Button,
  Dialog,
  Grid,
  Hidden,
  Tab,
  Tabs,
  Theme,
  Typography,
} from '@mui/material'
import { makeStyles } from '@mui/styles'
import React, { FC, useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { useSearchParams } from 'react-router-dom'
import { ConfigsContext } from '../common/configContext'
import { ConfigsType } from '../config'
import useUnit, { useWeightUnit } from '../hooks/useUnit'
import { RoleType, actions as appActions, logout } from '../redux/appReducer'
import { getData } from '../redux/itemReducer'
import { StateType } from '../redux/store'
import AdminTab from './Admin/AdminTab'
import HardwareTab from './Hardware/HardwareTab'
import MaterialTab from './Material/MaterialTab'
import MaterialGroupTab from './MaterialGroup/MaterialGroupTab'
import CabinetSidebar from './Sidebar/CabinetSidebar'
import PricingSidebar from './Sidebar/PricingSidebar'
import SlidingSidebar from './Sidebar/SlidingSidebar'
import DTool from './Three/DTool'
import Three from './Three/Three'
import UserAvatar from './UserAvatar'
import { Shift } from './common/Helpers'
import { UserType } from '../api/appAPI'
import AdminTabsWrapper from './Admin/AdminTabsWrapper'

interface TabPanelProps {
  children?: React.ReactNode
  index: any
  value: any
}

export function TabPanel(props: TabPanelProps) {
  const { children, value, index } = props

  return (
    <div role="tabpanel" hidden={value !== index}>
      {value === index && children}
    </div>
  )
}

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    // backgroundColor: theme.palette.background.paper,
    width: '100%',
  },
}))

interface IProps {
  role: RoleType
  user: UserType | undefined
  isDemo: boolean
  dToolMode: boolean
  activeTab: number
  configs: ConfigsType
  isInIframe: boolean
  isDataFetched: boolean

  getData(): void
  switchDToolMode(): void
  setActiveTab(value: number): void
  logout(): void
}

const AppTabs: FC<IProps> = (props) => {
  const classes = useStyles()

  const [searchParams] = useSearchParams()

  const { unit, setUnit } = useUnit()
  const { unit: weightUnit, setUnit: setWeightUnit } = useWeightUnit()
  const [unitDialogOpen, setUnitDialogOpen] = useState(false)

  useEffect(() => {
    props.getData()

    window.addEventListener('keydown', (e) => {
      if (e.key === 'm' && e.ctrlKey) {
        e.preventDefault()
        props.switchDToolMode()
      } else if (e.key === 'n' && e.ctrlKey && e.altKey) {
        if (window?.confirm('Changes will be lost. Are you sure?')) {
          const sceneID = localStorage.getItem('sceneID')

          localStorage.clear()

          if (sceneID) localStorage.setItem('sceneID', sceneID)

          window?.location.reload()
        }
      }
    })

    if (!unit) setUnitDialogOpen(true)
  }, [])

  const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    props.setActiveTab(newValue)
  }

  return !props.isDataFetched ? (
    <></>
  ) : (
    <ConfigsContext.Provider value={props.configs}>
      <div className={classes.root}>
        <AppBar
          position="static"
          color="default"
          style={{ flexDirection: 'row', alignItems: 'center' }}
        >
          <Tabs
            value={props.activeTab}
            onChange={handleChange}
            indicatorColor="primary"
            textColor="primary"
            // style={{ width: 'fit-content' }}
            // variant='standard'
          >
            <Tab label="Cabinet" value={0} />
            {(props.role === 'admin' ||
              props.isDemo ||
              (props.role === 'designer' &&
                props.user?.refEmail === 'troy@garagecabinets.com')) && (
              <Tab label="Pricing" value={1} />
            )}
            {props.isInIframe === false && props.role === 'admin' && (
              <Tab label="Parts" value={2} />
            )}
            {props.isInIframe === false && props.role === 'admin' && (
              <Tab label="Materials" value={3} />
            )}
            {props.isInIframe === false && props.role === 'admin' && (
              <Tab label="Material Groups" value={4} />
            )}
            {props.isInIframe === false && props.role === 'admin' && (
              <Tab label="Admin" value={5} />
            )}
          </Tabs>
          <Shift />
          <UserAvatar />
        </AppBar>

        <TabPanel value={props.activeTab} index={0}>
          <Box>
            <Hidden smDown>
              {props.dToolMode ? (
                <DTool />
              ) : (
                <Grid container>
                  <Grid item xs={9}>
                    <Three
                      myWidth={0.75}
                      configs={props.configs}
                      searchParams={searchParams}
                    />
                  </Grid>
                  <Grid item xs={3}>
                    <CabinetSidebar />
                  </Grid>
                </Grid>
              )}
            </Hidden>
            <Hidden mdUp>
              <Three
                myWidth={1}
                configs={props.configs}
                searchParams={searchParams}
              />
              <SlidingSidebar />
            </Hidden>
          </Box>
        </TabPanel>
        <TabPanel value={props.activeTab} index={1}>
          <Grid container>
            <Grid item xs={6}>
              <Three
                myWidth={0.5}
                configs={props.configs}
                searchParams={searchParams}
              />
            </Grid>
            <Grid item xs={6}>
              <PricingSidebar />
            </Grid>
          </Grid>
        </TabPanel>
        <TabPanel value={props.activeTab} index={2}>
          <AdminTabsWrapper>
            <HardwareTab />
          </AdminTabsWrapper>
        </TabPanel>
        <TabPanel value={props.activeTab} index={3}>
          <AdminTabsWrapper>
            <MaterialTab />
          </AdminTabsWrapper>
        </TabPanel>
        <TabPanel value={props.activeTab} index={4}>
          <AdminTabsWrapper>
            <MaterialGroupTab />
          </AdminTabsWrapper>
        </TabPanel>
        <TabPanel value={props.activeTab} index={5}>
          <AdminTabsWrapper>
            <AdminTab />
          </AdminTabsWrapper>
        </TabPanel>

        <Dialog
          open={unitDialogOpen}
          keepMounted
          // onClose={handleClose}
        >
          {/* <DialogTitle>Measurement</DialogTitle> */}
          <Box
            p={3}
            style={
              {
                // display: 'flex',
                // flexDirection: 'column',
                // justifyContent: 'space-evenly',
                // alignItems: 'center'
              }
            }
          >
            <Typography variant="h5">Choose Measurement Unit</Typography>
            <Box sx={{ width: '100%', display: 'flex', mt: 3, gap: 2 }}>
              <Button
                sx={{ flexGrow: 1 }}
                variant="contained"
                onClick={() => {
                  setUnit('cm')
                  setWeightUnit('kg')
                  setUnitDialogOpen(false)
                }}
              >
                CM/KG
              </Button>
              <Button
                sx={{ flexGrow: 1 }}
                variant="contained"
                onClick={() => {
                  setUnit('in')
                  setWeightUnit('lbs')
                  setUnitDialogOpen(false)
                }}
              >
                IN/LBS
              </Button>
            </Box>
          </Box>
        </Dialog>
      </div>
    </ConfigsContext.Provider>
  )
}

const mapStateToProps = (state: StateType) => ({
  role: state.appReducer.user?.role || 'none',
  user: state.appReducer.user,
  isDemo: state.appReducer.isDemo,
  isDataFetched: state.appReducer.isDataFetched,
  dToolMode: state.appReducer.dToolMode,
  activeTab: state.appReducer.activeTab,
  configs: state.appReducer.configs,
  isInIframe: state.appReducer.isInIframe,
})

export default connect(mapStateToProps, {
  getData,
  switchDToolMode: appActions.switchDToolMode,
  setActiveTab: appActions.setActiveTab,
  logout,
})(AppTabs)
